import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IaCreators } from '../../../store/actions/intelligence';
import Search from './searchBar';
import './Testar.scss';

export default function Teste() {
  const [token, setToken] = useState('');
  const [phrase, setphrase] = useState('');
  const [preview, setPreview] = useState([]);
  const [isIaEnabled, setIsIaEnabled] = useState(false);
  const { bot } = useSelector((state) => state.bots);
  const iaPreviewResult = useSelector(
    (state) => state.intelligence?.iaPreviewResult
  );
  const { iaPreview } = IaCreators;
  const dispatch = useDispatch();

  const getActiveToken = (inputBot) => {
    const platforms = inputBot?.ia?.platforms;

    const activePlatform = platforms?.find((platform) => platform.isActive);

    if (activePlatform) {
      setToken(activePlatform.token);
    }
  };

  useEffect(() => {
    getActiveToken(bot);
    setIsIaEnabled(bot?.iaEnabled);
  }, [bot]);

  useEffect(() => {
    if (iaPreviewResult) {
      const { data, message } = iaPreviewResult;
      setPreview(data);
      setphrase(message);
    }
  }, [iaPreviewResult]);

  const handleSubmitButton = (message) => {
    if (message?.length > 0 && token !== '') {
      dispatch(iaPreview({ token, message }));
      setphrase(message);
    }
  };

  const handleFormatIaType = (type) => {
    const iaTypes = {
      intent: 'Intenção',
      entity: 'Entidade',
    };

    let final = iaTypes[type];

    if (!final) {
      final = 'Não Detectado';
    }

    return final;
  };

  const handleFomartConfidence = (confidence) => {
    let percent;

    if (confidence) {
      percent = parseFloat(confidence) * 100;
      percent = percent.toString();
      percent = percent.substring(0, 4);
      percent += '%';
    }

    if (!percent) {
      percent = '';
    }

    return percent;
  };

  const handleFomartValue = (value) => {
    const platforms = bot?.ia?.platforms;

    const activePlatform = platforms?.find((platform) => platform.isActive);

    let final;

    if (value) {
      final =
        activePlatform.platform === 'luis'
          ? value.name.replace(/_/g, ' ')
          : value.value.replace(/_/g, ' ');
    }

    return final;
  };

  return (
    <>
      <Search
        onSubmit={(param) => handleSubmitButton(param)}
        iaEnabled={isIaEnabled}
      />
      {isIaEnabled && preview.length > 0 ? (
        <div className="table-container">
          <div className="response-title">
            <p>
              Resultados para frase <b>&quot;{phrase}&quot;</b>
            </p>
          </div>
          <div>
            <div className="table-header">
              <p>Objeto</p>
              <p>Confiança</p>
              <p>Identificação</p>
            </div>
            <ul className="table-itens">
              {preview?.map((item) => {
                return (
                  <li className="table-item">
                    <p>{handleFormatIaType(item.type)}</p>
                    <p>{handleFomartConfidence(item.confidence)}</p>
                    <p>{handleFomartValue(item)}</p>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      ) : (
        <div className="no-results">
          <p>Não existem resultados a serem exibidos</p>
        </div>
      )}
    </>
  );
}
